import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function getPurchaseOrdersReport() {
	return new Promise((resolve, reject) => {
		return apiClient
			.get('/dashboard-reports')
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
